import { useQuery } from '@tanstack/react-query';
import { ApiRoutes } from 'src/common/api/ApiRoutes';
import { useAxiosSocket } from 'src/common/api/AxiosContext';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';

export const useSocketViewSeatQuery = ({ seatChannel }: { seatChannel?: string }) => {
  const axios = useAxiosSocket();

  return useQuery(
    ['view-seat-selection', seatChannel],
    () => {
      console.log({ 'seatChannel push': seatChannel });
      return axios.get(`${ApiRoutes.viewSelectedSeat}/${seatChannel}`);
    },
    {
      select: res => res.data.data,
      keepPreviousData: true,
      retry: false,
      enabled: false,
      cacheTime: USE_QUERY_CONSTANTS.cacheMs,
      onError: error => {
        // if (window?.nham24?.request) window?.nham24?.request('consolelog', error);
        console.log({ error });
      },
    },
  );
};
